import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import { EvmTrxInfo, EvmTrxListInfo } from '~/api/repository'
import { addressTransactionListKey } from '~/api/service/query-keys.const'
import { ViewTransactionTable } from '~/components/table/transactions/transactionsTable.type'
import { IPagination } from '~/types/pagination.type'

export const useFetchTransactionListByAddress = (address: string, pagination: Ref<IPagination>) => {
  return useQuery([ ...addressTransactionListKey, address, pagination ], (): Promise<ViewTransactionByAddressList> => {
    return explorerApi.addressController.getTransactionList1({
      requestBody:{
        address,
        size: pagination.value.rowPerPage,
        page: pagination.value.page
      }
    }).then((res) => {
      return transactionListDto(res as EvmTrxListInfo)
    })
  })
}

export type ViewTransactionByAddressList = {
  totalCount: string
  viewCount: string
  VCNT: string;
  TCNT: string;
  TRXLIST: ViewTransactionTable[];
}
const transactionListDto = (transactionList: EvmTrxListInfo): ViewTransactionByAddressList => {
  return {
    ...transactionList,
    totalCount: setComma(transactionList.TCNT),
    viewCount: setComma(transactionList.VCNT),
    TRXLIST: transactionList.TRXLIST.map<ViewTransactionTable>((transaction: EvmTrxInfo) => {
      return {
        blockNumber: transaction.BNO,
        method: transaction.MTH,
        from: {
          type: transaction.ADDRSFROMINFO.ADT,
          address: transaction.ADDRSFROMINFO.ADDR,
          name: transaction.ADDRSFROMINFO.NN
        },
        to: {
          type: transaction.ADDRSTOINFO.ADT,
          address: transaction.ADDRSTOINFO.ADDR,
          name: transaction.ADDRSTOINFO.NN
        },
        value: setComma(transaction.VAL),
        transactionFee: setComma(transaction.TRXF),
        transactionHash: transaction.TRXHA,
        age: transaction.AG,
        unixTimeStamp: secondsToDate(transaction.UT),
      }
    })
  }
}